import { Component, OnInit } from '@angular/core';
import { BaseComponentService } from '../../../../services/base-component.service';
import { AslibGridComponent } from '@aslib/components';
import { AslibModalComponent, IAslibModalOptions } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { LiquidacaoEnvio } from '../../../../models/pagamento/liquidacao-envio';

@Component({
    selector: 'gpa-liq-empenho-processado',
    templateUrl: './processado-liq-empenho.component.html',
    styles: [`.fieldRow {
      height:1px; width:100%; border:none; color:#2E2E2E; background-color:#2E2E2E; margin-left:8px; margin-top: 0px; margin-bottom: 25px;'
      }`],
    providers: [BaseComponentService]
})

export class ProcessadoLiqEmpenhoComponent  extends BaseComponentService implements OnInit {

  subscription: Subscription;

  // lista de liquidações que serão enviadas. 
  // Esta lista será preenchida com algumas informações de empenhos retornados.
  liquidacoesEnvio: LiquidacaoEnvio[];
  
  itemSelecionado: LiquidacaoEnvio;
  permitirEnvio: boolean;
  projetoIntegrado: string

  ngOnInit() {
    this.projetoIntegrado = sessionStorage.getItem('ProjetoIntegrado');
    this.liquidacoesEnvio = [];

    if(sessionStorage.getItem('IdEmp') != null) {
      const emp = Number(sessionStorage.getItem('IdEmp'));
      this.getEmpsProcessados(emp);
    }

    ProcessadoLiqEmpenhoComponent.updateList.subscribe(data => {
      this.fecharModal();
    });
  }

  public static updateList: Subject<any> = new Subject();

  getEmpsProcessados(fileId: number): void {
    this._service.routePrefix = '/api/EmpRetorno/ObterEmpsRetornados'.concat(`/${fileId}/${true}`);

    this.aslibLoadingService.start();

    this.subListar = this._service.getAll('gpa').subscribe(data => {
      this.aslibLoadingService.complete();

      const listaProcessado = data;

      if (listaProcessado) {
          listaProcessado.forEach(emp => {
            const liq: LiquidacaoEnvio = new LiquidacaoEnvio();

            liq.codigoProjeto = emp.codigoProjeto;
            liq.anoExercicio = emp.anoExercicio;
            liq.codigoCredor = emp.codigoCredor;
            liq.cnpjCpfCredor = emp.cnpjCpfCredor;
            liq.nomeCredor = emp.nomeCredor;
            liq.numeroProcessoSEI = emp.numeroProcessoSEI;
            liq.numeroEmpenho = emp.numEmp;
            liq.valor = emp.valorEmpenho;
            liq.enviada = emp.enviadoNaLIQ;
            liq.numeroObservacao = emp.numeroObservacao;

            this.liquidacoesEnvio.push(liq);
          });

          this.permitirEnvio = listaProcessado.length > 0 && !this.liquidacoesEnvio[0].enviada;
      }
      else {
        this.exibirAviso('Arquivo em processamento.');
      }
    },
    (error) => {
      this.aslibLoadingService.complete();
      this.exibirErro(error);
    },
    () => {
      this.aslibLoadingService.complete();
      }
    );

  }

  enviarLIQ(grid: AslibGridComponent) {

    if (this.liquidacoesEnvio.length === 0) {
      this.aslibLoadingService.complete();
      this.exibirAviso('Não há dados para a geração e envio da LIQ.');
    }

    this._service.routePrefix = '/api/LiqEnvio';
    this.aslibLoadingService.start();

    this.subSave = this._service.add(this.liquidacoesEnvio, 'gpa').subscribe(data => {
      this.permitirEnvio = false;

      this.aslibLoadingService.complete();

      // atualiza a coluna de sinalização de envio.
      for (let index = 0; index < this.liquidacoesEnvio.length; index++) {
        this.liquidacoesEnvio[index].enviada = true;
      }

      this.exibirSucesso('As LIQs foram enviadas com sucesso.');
    },
      erro => {
        this.aslibLoadingService.complete();
        this.exibirErro(erro);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );
  }

  exibirDadosComplementares(conteudo: any, item: LiquidacaoEnvio) {
    this.itemSelecionado = item;
 
    const options: IAslibModalOptions = {
      title: 'Dados Complementares',
      backdrop: 'static',
      footerVisible: false,
      size: 'lg',
      content: conteudo
    };

    this.aslibModal.open(options).result.then(
      () => { },
      () => { }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq-empenho/processado/processado-liq-empenho.component.ts